import { Typography } from '@material-ui/core';
import { useStyles } from './styles';

function EquipmentIndex({ index, redeId }) {
  const classes = useStyles({ redeId });
  return(
    <div className={classes.container}>
      <Typography className={classes.index}>
        {index}
      </Typography>
    </div>
  );
}

export default EquipmentIndex;